import {createSlice} from '@reduxjs/toolkit';

const accountsSlice = createSlice({
    name: 'accounts',
    initialState: {list: [], initialized: false},
    reducers: {
        setAccounts: (state, action) => {
            state.list = action.payload;
            state.initialized = true;
        },
        addAccount: (state, action) => {
            state.list.push(action.payload);
        },
        updateAccountById: (state, action) => {
            const idx = state.list.findIndex(a => a.id === action.payload.id);
            if (idx !== -1) state.list[idx] = action.payload;
        },
        removeAccountById: (state, action) => {
            state.list = state.list.filter(a => a.id !== action.payload);
        },
        removeAccountsBySourceId: (state, action) => {
            state.list = state.list.filter(a => a.sourceId !== action.payload);
        },
    },
    selectors: {
        selectAccounts: (state) => state.list,
        selectAccountsById: (state) => {
            const res = {};
            state.list.forEach(a => res[a.id] = a);
            return res;
        },
        selectAccountsInitialized: (state) => state.initialized,
    },
});

export const {
    setAccounts,
    addAccount,
    updateAccountById,
    removeAccountById,
    removeAccountsBySourceId,
} = accountsSlice.actions;
export const {selectAccounts, selectAccountsInitialized, selectAccountsById} = accountsSlice.selectors;
export const {reducer} = accountsSlice;
